import { AfterLoginHeader } from "@/components/Header/AfterLoginHeader";
import { isMobileViewHook } from "customHooks/isMobileViewHook";
import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import Drawer from "react-modern-drawer";
import { useSelector } from "react-redux";
import SideBar from "../SideBar";
import classes from "./SideBarSkeleton.module.css";

const SideBarSkeleton = ({ children, headerHeading, icon }) => {
  const { isSidebarCollapsed } = useSelector((state) => state.authReducer);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  useEffect(() => {
    isMobileViewHook((e) => {
      setIsMobile(e);
    });
  }, []);
  return (
    <>
      <style>
        {`
        .drawerContainer{
          width:270px !important;
          background-color:transparent !important;
        }
       `}
      </style>
      <div className={`${classes.wrapper} g-0`}>
        <div
          className={[
            !isMobile && classes.sidebarDiv,
            isSidebarCollapsed && classes.iscollapsed,
          ].join(" ")}
        >
          {!isMobile ? (
            <SideBar isCollapsed={isSidebarCollapsed} />
          ) : (
            <Drawer
              open={isOpen}
              onClose={toggleDrawer}
              direction="left"
              className="drawerContainer"
            >
              <SideBar isCollapsed={false} isMobile={isMobile} />
            </Drawer>
          )}
        </div>
        <div
          className={[
            classes.contentDiv,
            isSidebarCollapsed ? classes.contentIsCollapsed : "",
          ].join(" ")}
        >
          <AfterLoginHeader
            drawerBtn={
              isMobile && (
                <GiHamburgerMenu
                  className={[classes.GiHamburgerMenuMobile]}
                  onClick={() => {
                    toggleDrawer();
                  }}
                />
              )
            }
            header={headerHeading}
            icon={icon}
          />
        </div>
        <div className={classes.pageMain}>{children}</div>
      </div>
    </>
  );
};

export default SideBarSkeleton;
